export default {"src":"/_next/static/media/ic-tab-gray.537b5d34.svg","height":14,"width":15,"blurWidth":0,"blurHeight":0};